import React from 'react';
import _ from 'underscore';

import { CommonStyles } from '../../common/react/CommonStyles';
import { DeprecatedReactMenu } from '../../common/react/components/Menu';
import { HeaderStyles } from './HeaderStyles';

export class HeaderMenuButton extends React.PureComponent<HeaderMenuButton.Props, any> {

  static displayName = 'HeaderMenuButton';

  static element = React.createFactory(HeaderMenuButton);

  public render() {

    const menuButtonStyle: any = {
      fontWeight: 'normal',
      display: 'block',
      height: HeaderStyles.TopBarHeight,
      lineHeight: HeaderStyles.TopBarLineHeight,
      fontSize: CommonStyles.Sizes.HeaderFontSize,
      letterSpacing: HeaderStyles.LetterSpacing,
    };

    // Add icon
    if (this.props.iconPath) {
      // using icon path reduces flickering of icons
      _.extend(menuButtonStyle, this.props.style, {height: '24px'});
      const wrappingDivStyle = {...CommonStyles.Layout.FlexBlockVerticalCenter, marginTop: '15px', height: '24px'};

      return (
        <>
          <div title={this.props.title} style={wrappingDivStyle} role={ 'button' } tabIndex={this.props.tabIndex} aria-haspopup={ this.props.ariaPopup } aria-expanded={ this.props.ariaExpanded } aria-label={this.props.ariaLabel} className={'tb-header-menu-button'}>
            <img src={this.props.iconPath} style={menuButtonStyle} alt={this.props.altText || ''}/>
          </div>
        </>
      );

    } else if (this.props.iconUrl) {
      _.extend(menuButtonStyle, {
        paddingLeft: 24,
        backgroundImage: this.props.iconUrl,
        backgroundPosition: 'left center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '24px 24px',
      });
    }

    // Apply style overrides
    _.extend(menuButtonStyle, this.props.style);

    return React.createElement('span', { style: menuButtonStyle, tabIndex: this.props.tabIndex, role: 'button', ariaHaspopup: this.props.ariaPopup, ariaLabel: this.props.ariaLabel, ariaExpanded: this.props.ariaExpanded, className: 'tb-header-menu-button'});
  }
}

export module HeaderMenuButton {

  export interface Props extends DeprecatedReactMenu.ButtonProps {
    iconUrl?: string;         // The icon (if any) to display
    label?: string;           // The button's label
    style?: any;              // Style to apply to the header button (overrides defaults)
    iconPath?: string;        // The icon path if want to use an img tag instead of background-image
    altText?: string;         // The alt text for the icon. Only used if iconPath is provided
    tabIndex: number;        // The tabindex value for the icon
    ariaPopup: 'menu' | 'dialog';      // The aria popup type
    ariaLabel: string;           // The title for the icon
    ariaExpanded: boolean;      // expansion state of the dialog
    title: string;
  }

}
